import React, { Component } from 'react';
import { connect } from 'react-redux';

// Actions, Utils
import {
    getProducts, getPriceMatrices, applyPriceMatrix, getProductTypes,
    importProductsFromCatalog, clearProductList, clearProductTypeList
} from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { getProductList } from 'actions/ReportsAction';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
import { productListCrumb } from 'utils/breadcrumbInfo';
import { mapProductList } from 'utils/mappers';

// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import FileUploadSKUMapping from 'screens/components/basic/FileUploadSKUMapping';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import ProductSearchFields from './Components/searchFields';
import ToggleButtonsGroup from './Components/ToggleButtonsGroup';

const pageName = "productList";

class ProductList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            value: 'Active',
            status: 'Active',
            orderBy: "DESC",
            sortBy: ""
        };
    }

    componentWillMount() {
        this.props.getProductTypes();
        this.getProducts();
    }

    componentDidMount() {
        if (this.props.isMedical) {
            this.props.getPriceMatrices();
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.savePriceMatrixProduct != undefined && newProps.savePriceMatrixProduct !== this.props.savePriceMatrixProduct) {
            if (newProps.savePriceMatrixProduct) {
                this.savePriceMatrixSuccess();
            }
            else {
                this.savePriceMatrixFailure();
            }
        }

        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess) || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.importedProductsTime !== undefined && newProps.importedProductsTime !== null && newProps.importedProductsTime !== this.props.importedProductsTime) {
            let importCount = newProps.importedProducts.split(',').length;
            this.props.showError(`Import success, ${importCount} new products are imported. SKUs are ${newProps.importedProducts}`);
        }

        if (newProps.importedProductsErrorTime !== undefined && newProps.importedProductsErrorTime !== null && newProps.importedProductsErrorTime !== this.props.importedProductsErrorTime) {
            this.props.showError(`${newProps.importedProductsError}`);
        }

        if (newProps.uploadProductsTime && newProps.uploadProductsTime !== this.props.uploadProductsTime) {
            this.props.showError(`upload success`);
            this.getProducts();
        }

        if (newProps.isMedical != undefined && newProps.isMedical !== this.props.isMedical && newProps.isMedical) {
            this.props.getPriceMatrices();
        }
    }

    componentWillUnmount() {
        this.props.clearProductList();
        this.props.clearProductTypeList();
    }

    saveSuccess = () => {
        this.props.callListView();
        this.props.showProductSuccess(this.state.status === "EDIT" ? LOOKUP.product.messages.editedMessage : LOOKUP.product.messages.createdMessage);
    }

    saveFailure = () => {
        this.props.showProductError(LOOKUP.product.messages.saveErrorMessage);
    }

    savePriceMatrixSuccess = () => {
        this.props.showSuccess("Price Matrix applied successfully.");//LOOKUP.priceMatrix.messages.);
        this.getProducts();
        this.props.clearFormInput("applyPriceMatrixProductSaveSuccess");
    }

    savePriceMatrixFailure = () => {
        this.props.showError("Error applying Price Matrix.");//LOOKUP.priceMatrix.messages.saveErrorMessage);
    }

    viewProduct = (id) => {
        this.props.navigate(`/product/${id}`);
    }

    editProduct = (id) => {
        this.props.navigate(`/product/edit/${id}`);
    }

    changePage = e => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getProducts);
    }

    getProducts = (page) => {
        const model = {
            branchId: this.props.branchId,
            page: page || this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            searchText: this.props.searchText || "",
            descriptionStatus: this.props.descriptionFilter ? this.props.descriptionFilter : 0,
            categoryId: this.props.categoryId > 0 ? parseInt(this.props.categoryId) : null,
            sku: this.props.SKUFilter || "",
            priceMatrixId: this.props.matrixFilter > 0 ? parseInt(this.props.matrixFilter) : null,
            status: this.props.statusFilter ? this.props.statusFilter : 'None',
            imageStatus: this.props.imageFilter ? this.props.imageFilter : 0,
            typeId: this.props.typeFilter > 0 ? this.props.typeFilter : null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            universalProductCode: this.props.universalProductCode || "",
            productCode: this.props.productCode || "",
            eliteStatus: this.props.eliteFilter ? this.props.eliteFilter : 0
        };
        this.props.getProducts(model);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getProducts);
    }

    downloadProductList = () => {
        const queryParams = new URLSearchParams({
            branchId: this.props.branchId,
            searchText: this.props.searchText || "",
            descriptionStatus: this.props.descriptionFilter ? this.props.descriptionFilter : 0,
            categoryId: this.props.categoryId > 0 ? parseInt(this.props.categoryId) : null,
            sku: this.props.SKUFilter || "",
            priceMatrixId: this.props.matrixFilter > 0 ? parseInt(this.props.matrixFilter) : null,
            status: this.props.statusFilter ? this.props.statusFilter : 'None',
            imageStatus: this.props.imageFilter ? this.props.imageFilter : 0,
            typeId: this.props.typeFilter > 0 ? this.props.typeFilter : null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            universalProductCode: this.props.universalProductCode || "",
            productCode: this.props.productCode || "",
            eliteStatus: this.props.eliteFilter ? this.props.eliteFilter : 0
        });
        const formattedDate = this.getFormattedDate();
        const filename = `ProductCatalog-${formattedDate}.xlsx`;
        this.props.getProductList(`reports/excel/ExportProductCatalog?${queryParams.toString()}`, filename);
    }

    getFormattedDate() {
        const now = new Date();
        // Format date as YYYYMMDD
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(now.getDate()).padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;
        return formattedDate;
    }

    cleanSearch = () => {
        this.props.clearFormInput('productListCategoryFilter');
        this.props.clearFormInput('productListNameFilter');
        this.props.clearFormInput('productListSkuNumberFilter');
        this.props.clearFormInput('productListStatus');
        this.props.clearFormInput('productListPriceMatrix');
        this.props.clearFormInput('productListType');
        this.props.clearFormInput('productListUniversalProductCode');
        this.props.clearFormInput('productListProductCode');

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "",
                orderBy: "DESC"
            };
        }, () => this.getProducts());
    }

    mapPriceMatricesToSelectItem = () => {
        let list = [];
        list.push({ text: "All", value: "0" });
        (this.props.priceMatrices || []).map((item) => {
            list.push(
                {
                    text: item.name,
                    value: item.id
                }
            );
        });
        return list;
    }

    applyPriceMatrix = () => {
        if (this.props.selectedRows && this.props.selectedPriceMatrix) {
            let productIds = [];
            if (this.props.selectedRows === 'all') {
                productIds = this.props.products.map(p => {
                    return p.id;
                });
            }
            else {
                this.props.selectedRows.map((rowIndex) => {
                    productIds.push(parseInt(this.props.products[rowIndex].id));
                });
            }

            let model = {
                priceMatrixId: parseInt(this.props.selectedPriceMatrix),
                productIds: productIds
            };
            this.props.applyPriceMatrix(model);
        }
    }

    handleChange = (event) => {
        this.setState(pState => {
            return {
                ...pState,
                [event.target.name]: event.target.value,
            };
        });
    };

    sort = (sortBy) => {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getProducts);
    }

    importProductsFromCatalog = () => {
        this.props.importProductsFromCatalog(this.props.branchId);
    }

    render() {
        const p = this.props;
        const s = this.state;
        const priceMatrices = this.mapPriceMatricesToSelectItem();

        let categories = [];
        categories.push({ text: "All", value: "0" });
        const cat = this.props.productTypes && this.props.productTypes.length > 0 ? this.props.productTypes[0].categories : [];
        cat.map(item => {
            categories.push({
                text: item.name,
                value: item.id.toString()
            });
        });

        categories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });

        return (
            <Grid headerContent={productListCrumb}>
                <PageHeaderWithButton title={LOOKUP.product.listTitle}>
                    {(p.isHighTide || p.isInspired) && (
                        <FileUploadSKUMapping branchId={p.branchId} disabled={!this.props.canAddEditProduct} />
                    )}
                    {!this.props.isHighTide && !this.props.isInspired && !this.props.isVape && !this.props.isMedical && (
                        <ToggleButtonsGroup mainButtonStyle={{ width: "220px", backgroundColor: "#5F4BB3" }} customClassName={"btnNewBrandPOS"} />
                    )}
                    {!this.props.isHighTide && !this.props.isInspired && !this.props.isVape && !this.props.isMedical && (
                        <Button
                            style={{ marginLeft: "1em" }}
                            type="ImportExportButton"
                            mini={true}
                            label="Import From Catalog"
                            id="importFromCatalogButton"
                            className="primary-color-bg"
                            onTouchTap={() => this.importProductsFromCatalog()}
                        />
                    )}
                    <Button
                        style={{ marginLeft: "1em" }}
                        type="AddButton"
                        mini={true}
                        label="ADD NEW PRODUCT"
                        id="addNewProductButton"
                        className="bg-light-green"
                        onTouchTap={() => this.props.navigate("/product/add")}
                        disabled={!this.props.canAddEditProduct}
                    />
                </PageHeaderWithButton>
                <ProductSearchFields
                    pageName={pageName}
                    cleanSearch={this.cleanSearch}
                    search={this.search}
                    handleChange={this.handleChange}
                    downloadProductList={this.downloadProductList}
                    categories={categories}
                    priceMatrices={priceMatrices}
                    applyPriceMatrix={this.applyPriceMatrix}
                    isHighTide={this.props.isHighTide}
                />
                <CardSimple>
                    <GenericTable
                        compName="productListTable"
                        className=""
                        tableHeaderClassName="table-products-header"
                        tableBodyClassName="table-products"
                        adjustForCheckbox={true}
                        displaySelectAll={true}
                        displayRowCheckbox={true}
                        enableSelectAll={true}
                        multiSelectable={true}
                        selectable={false}
                        columns={this.props.memberEnabled ? this.props.isHighTide ? LOOKUP.product.tableColumnsWithMemberElitePrice : this.props.isInspired ? LOOKUP.product.tableColumnsWithMemberPromotionPrice : LOOKUP.product.tableColumnsWithMember : LOOKUP.product.tableColumns}
                        rows={mapProductList(this.props.products, this.editProduct, this.props.memberEnabled, this.props.canAddEditProduct, this.props.isHighTide, this.props.isInspired)}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={p.productsLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={this.changePage}
                        maxButtons={8}
                    />
                </CardSimple>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        canAddEditProduct: state.common.authenticatedUser && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanAddEditProduct")),
        branchId: state.common.branchId,
        products: state.entity.productList,
        productsLength: state.entity.productListLength,
        priceMatrices: state.entity.priceMatricesList,
        selectedPriceMatrix: state.form["productListPriceMatrix"],
        selectedRows: state.form["productListTableSelectedRows"],
        savePriceMatrixProduct: state.form["applyPriceMatrixProductSaveSuccess"],
        productTypes: state.entity.productTypesList,
        categoryId: state.form["productListCategoryFilter"],
        searchText: state.form["productListNameFilter"],
        descriptionFilter: state.form["productListHasDescription"],
        SKUFilter: state.form["productListSkuNumberFilter"],
        statusFilter: state.form["productListStatus"],
        imageFilter: state.form["productListHasImage"],
        typeFilter: state.form["productListType"],
        universalProductCode: state.form["productListUniversalProductCode"],
        productCode: state.form["productListProductCode"],
        matrixFilter: state.form["productListPriceMatrix"],
        memberEnabled: state.common.applicationSettings.memberEnabled,
        importedProducts: state.entity.importedProducts,
        importedProductsError: state.entity.importedProductsError,
        importedProductsTime: state.entity.importedProductsTime,
        importedProductsErrorTime: state.entity.importedProductsErrorTime,
        isMedical: state.common.applicationSettings.isMedical,
        isVape: state.common.applicationSettings.isVape,
        eliteFilter: state.form["productListEliteFilter"],
        uploadProductsTime: state.entity.uploadProductsTime,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showProductSuccess: (message) => dispatch(showSnackbar(message)),
        getProducts: (model) => dispatch(getProducts(model)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        applyPriceMatrix: (model) => dispatch(applyPriceMatrix(model)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getProductTypes: () => dispatch(getProductTypes()),
        importProductsFromCatalog: (branchId) => dispatch(importProductsFromCatalog(branchId)),
        clearProductList: () => dispatch(clearProductList()),
        clearProductTypeList: () => dispatch(clearProductTypeList()),
        getProductList: (url, name) => dispatch(getProductList(url, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ProductList));
